/**
 * Browsers have this feature where pinch will automatically
 * zoom in/out of the webpage as an accessibility feature. Doing so
 * can distrupt gameplay by cropping the screen (including UI) and
 * it's not obvious to users that this is happening.
 *
 * Certain browsers (eg. mobile) will respect the user-scalable meta tag.
 * eg. <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no">
 * However, other browsers (eg. desktop Chrome) will not respect this meta tag.
 *
 * The solution below is used by Google Maps to disable the native window view pinch to zoom.
 */
export function disableBrowserDefaultPinchToZoom() {
  window.addEventListener(
    "wheel",
    (e) => {
      // Detects pinch to zoom (wheel + ctrl key).
      if (e.ctrlKey) {
        e.preventDefault();
      }
    },
    { passive: false }
  );
}
